import React from "react";
import {useTranslation} from "react-i18next";
import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import WarningIcon from "assets/icons/WarningIcon";

const useStyles = makeStyles((theme) => ({
  label: {
    backgroundColor: theme.palette.primary.contrast,
    zIndex: 1,
    position: "absolute",
    top: -7,
    left: 10,
    padding: theme.spacing(0, 1),
    color: (props) =>
      props.hasErrors ? theme.palette.error.main : theme.palette.primary.main,
  },
  select: {
    border: "2px solid",
    borderRadius: 12,
    borderColor: (props) =>
      props.hasErrors ? theme.palette.error.main : theme.palette.primary.main,
    "& fieldset": {border: "none"},
  },
  selectIcon: {color: theme.palette.primary.main + "!important"},
  selectMenu: {opacity: 0.5},
  menu: {
    maxHeight: 300,
    backgroundColor: theme.palette.primary.contrast,
    zoom: 0.7,
  },
  required: {
    paddingLeft: 3,
    fontSize: 21,
  },
  caption: {
    margin: "-3px 14px 0px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

export default function KeycardCountryPicker({field, label, onChange}) {
  const {t} = useTranslation();
  const classes = useStyles();

  return (
    <FormControl fullWidth>
      <InputLabel
        shrink
        className={classes.label}
        htmlFor={`${label}-country-selector`}
      >
        {label}
        {!!field.required ? (
          <span className={classes.required}>{"*"}</span>
        ) : (
          ""
        )}
      </InputLabel>
      <Select
        open={false}
        displayEmpty
        value={field.value}
        variant="outlined"
        id={`${label}-country-selector`}
        className={classes.select}
        classes={{icon: classes.selectIcon, selectMenu: classes.selectMenu}}
        inputProps={{autoFocus: true}}
        MenuProps={{classes: {paper: classes.menu}}}
        onChange={(e) => onChange(e.target.value)}
        IconComponent={ExpandMoreIcon}
      >
        <MenuItem disabled value={""}>
          {label}
        </MenuItem>
      </Select>
      {!!field.error && (
        <div className={classes.caption}>
          <WarningIcon color="error" style={{marginTop: 8}} />
          <Typography
            variant="caption"
            color={"error"}
          >{`${t("language")} ${t("is_required")}`}</Typography>
        </div>
      )}
    </FormControl>
  );
}
